export interface IPalette {
	alert: string
	blackDark: string
	blue: string
	darkBlue: string
	gray: string
	grayDark: string
	grayDark2: string
	grayBlue: string
	grayLight2: string
	info: string
	iron: string
	lightGray: string
	orange: string
	primary: string
	radiantBlue: string
	submarine: string
	success: string
	warning: string
	white: string
	yellow: string
	yellowDark: string
}

const colors: any = {
	default: {
		alert: '#f26c59',
		blackDark: '#161E21',
		blue: '#00a8ff',
		darkBlue: '#152D39',
		gray: '#7f7f7f',
		grayDark: '#4f4f4f',
		grayDark2: '#404040',
		grayBlue: '#5b6d79',
		grayLight2: '#8b9195',
		info: '#003753',
		iron: '#cdd3d7',
		lightGray: '#a6a6a6',
		orange: '#ff9100',
		primary: '#005785',
		radiantBlue: '#00A8FF',
		submarine: '#b8c0c6',
		success: '#5fd598',
		warning: '#ffa800',
		white: '#ffffff',
		yellow: '#feb500',
		yellowDark: '#ffc24d',
	},
}

let _palette = 'default'

const getPalette = (palette = ''): IPalette => {
	_palette = palette || _palette
	return colors[_palette] || colors.default
}

export default getPalette
